export default __webpack_public_path__ + "static/media/1l-act.2132148f.svg";